/* eslint-disable */
import UseAxios from '../../../Api/http/http';
import { certificationList } from '../../../Api/request/certification';
import {
  addCertificationMapData,
  editCertificationMapData,
} from '../../../Api/request/certificationmap';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
dayjs.locale({
  ...dayjs.Ls.en,
  formats: {
    ...dayjs.Ls.en.formats,
    L: 'DD-MM-YYYY',
  },
});

export const submitAction = async (data, isEditMode) => {
  try {
    const response = await UseAxios(
      isEditMode
        ? editCertificationMapData(data)
        : addCertificationMapData(data),
    );
    return response;
  } catch (error) {
    console.error('Error in submitAction:', error);
    throw error;
  }
};

export const addValidityToAchievedDate = (achievedDate, validityInYears) => {
  const [yearsValue = '0', monthsValue = '0'] = String(validityInYears).split('.');
  const years = Number(yearsValue) || 0;
  const months = Number(monthsValue) || 0;
  const totalMonths = (years * 12) + months;
  return dayjs(achievedDate).add(totalMonths, 'month');
};

// Utility function for handling date changes
export const handleDateChangeUtil = (date, newCertification, editItem) => {
  const achievedDate = dayjs(date);
  let expiryDate;

  if (
    newCertification.validity !== null
    && newCertification.validity !== undefined
    && newCertification.validity !== ''
  ) {
    expiryDate = addValidityToAchievedDate(achievedDate, newCertification.validity);
  } else if (editItem?.expiredDate && editItem.expiredDate !== 'N/A' && editItem.expiredDate !== '') {
    // Only use editItem expired date if it's not N/A or empty
    expiryDate = dayjs(editItem.expiredDate);
  }

  if (expiryDate && expiryDate.isValid()) {
    const formattedExpiryDate = expiryDate.format('DD-MM-YYYY');
    if (achievedDate.isValid()) {
      return { valid: true, achievedDate, formattedExpiryDate };
    } else {
      console.error('Invalid date');
      return { valid: false };
    }
  } else {
    console.error('No validity or expired date available');
    return { valid: false };
  }
};

export const fetchCertifications = async () => {
  try {
    const response = await UseAxios(certificationList());
    const result = response.data.certificationDetails
      .filter((certificate) => certificate.isActive)
      .map((certificate) => ({
        id: certificate.certificationId,
        name: certificate.certificationName,
        validity: certificate.validity,
      }));
    return result;
  } catch (error) {
    console.error('certification error', error);
    return [];
  }
};

export const setMapRowData = (submitData, newCertification, row = {}) => {
  row.userName = submitData.employeeName;
  row.userEmail = submitData.employeeEmail;
  row.userId = row.USER_ID = row.employeeID = submitData.employeeID;
  row.vertical = submitData.vertical;
  row.employeeStatus = submitData.employeeStatus;
  row.certificationId = newCertification.id;
  row.certifications = newCertification.name;
  row.achievedDate = submitData.certificationAchievedDate;
  row.expiredDate = submitData.certificationExpiryDate;
  row.lastUpdatedBy = submitData.lastUpdatedBy;

  return row;
};

function areDatesMatching(isoDate, formattedDate) {
  // Handle N/A, null, undefined, or empty values
  const isIsoDateNA = !isoDate || isoDate === 'N/A' || isoDate === '';
  const isFormattedDateNA = !formattedDate || formattedDate === 'N/A' || formattedDate === '';
  
  // If both are N/A (or null/empty), they match
  if (isIsoDateNA && isFormattedDateNA) {
    return true;
  }
  
  // If one is N/A and the other isn't, they don't match
  if (isIsoDateNA !== isFormattedDateNA) {
    return false;
  }
  
  // Both have actual dates - compare them
  const formattedISODate = dayjs(isoDate).format('DD-MM-YYYY');
  return formattedISODate === formattedDate;
}

export const enableSaveAction = (isEditMode, editItem, currentItem, certificationValidity, achievedDate) => {
  if (isEditMode) {
    const isoDate = editItem.expiredDate;
    const formattedDate = currentItem.certificationExpiryDate;

    // Enable if employee changed
    if (currentItem.employeeID && currentItem.employeeID !== editItem.userId)
      return 0;
    
    // Enable if certification changed
    else if (currentItem.certificationID !== editItem.certificationId) 
      return 0;
    
    // Enable if dates don't match
    else if (!areDatesMatching(isoDate, formattedDate)) {
      // Allow update if the new expiry date is different from the original
      // This includes cases where expiry date exceeds the calculated validity
      return 0;
    }
    
    // Check if the edited expiry date exceeds the calculated validity
    // This handles the case where user manually sets an expiry date later than the calculated one
    else if (certificationValidity && achievedDate && formattedDate && formattedDate !== 'N/A') {
      const calculatedExpiryDate = addValidityToAchievedDate(achievedDate, certificationValidity);
      const editedExpiryDate = dayjs(formattedDate, 'DD-MM-YYYY');
      
      // Enable button if edited expiry date exceeds (is after) the calculated validity
      if (editedExpiryDate.isAfter(calculatedExpiryDate, 'day')) {
        return 0;
      }
    }
    
    // Disable if nothing changed
    return 1;
  } else return 0;
};
